module.exports = __webpack_public_path__ + "static/media/filter-feature-barrier-free.83b0aee6.svg";